import { getUUID } from "../utils/helpers";
const env = process.env.NODE_ENV;
const setData = true;
const setObj = obj => setData ? ({...obj}) : ({});

const isDevelopment = env === "development";

export const initPage = 0;

export const beneficiarioDefault = {    
    key: getUUID(),
    nombres: '',
    parentesco: '',
    porcentaje: '',
};

export const otroSeguroDefault = {    
    key: getUUID(),
    companyName: '',
    amount: 0,
    coverages: '',
};

export const debitoAutomaticoDefault={
    acepta:undefined,
    tipoTarjeta:undefined,
    pais:505,
    bancoEmisor:0,
    celular:undefined,
    correo:undefined
};

const cotizacionMochaded = isDevelopment ? {
    nombres: 'Eddy',
    apellidos: 'Antonio',
    email: 'eortiza@lafise.com',
    telefono: '88888888',
    edad: '34',

    sa: '10000',
    frecuenciaPagos: '1',
    ocupacion: '0',
    prima: '--',
    cuota: '--',
    aceptTerminos: true,
} : {};

export const cotizacion = {
    nombres: '',
    apellidos: '',
    email: '',
    telefono: '',
    edad: '0',

    sa: '10000',
    frecuenciaPagos: '1',
    ocupacion: '0',
    prima: '--',
    cuota: '--',

    catactiv: '0',
    aceptTerminos: false,
    ...setObj(cotizacionMochaded)
}


const polizaMochaded = isDevelopment ? {

    id:0,    
    tipoId: '1',
    identificacion: '570-050591-00000M',
    nacionalidad: '505',
    sexo: 'M',
    direccion: 'Managua',
    direccionCobro:'Managua',
    fechaNacimiento: new Date(1987, 5, 12),
    estadoCivil: '1',
    departamento: '31',
    municipio: '1',
    telefonoCasa: '00000000',    
    profesion: '1',        
    hasHouse: true,
    hasCar: true,
    hasChildren: true,

    actividad: '1',
    empresaTrabaja: 'LAFISE',
    telefono:'22558888',
    ocupacion: '1',
    ingresoMensual: '10000',
    ingresoMoneda: 'C$',
    origenFondo: '2',
    origenFondoOtros: '',

    estatura:'1.68',
    estaturaUnidades:'0',
    peso:'160',
    pesoUnidades:'0',
    lateralidad:true,

    sa: '10000',
    prima: '41.07',
    tipPago: undefined,
    primeraCuota: '41.07',
    pagoMoneda: 'U$',

    nombreTarjeta: 'Eddy',
    numeroTarjeta: '',
    codigoSeguridad: '',
    fechaExpiracion: '',

    beneficiarios: [{ key: getUUID(),
        nombres: 'Leo',
        parentesco: 'H',
        porcentaje: '100', }],

    otherInsures: undefined,
    clausulaArbitraje: true,
}: {};



export const polizaDefault = {        
    file: {
        0: null,
        1: null
    },
    id:0,   
    nombres: '',
    apellidos: '',
    tipoId: '1',
    identificacion: '',
    fechaVigencia: null,
    nacionalidad: '505',
    sexo: 'F',
    direccion: '',
    direccionCobro:'',
    fechaNacimiento: null,
    estadoCivil: '1',
    pais: '505',
    departamento: '-1',
    municipio: '',
    telefonoCasa: '',
    telefonoCelular: '',
    email: '',
    profesion: '',        
    hasHouse: undefined,
    hasCar: undefined,
    hasChildren: undefined,

    actividad: '',
    empresaTrabaja: '',
    telefono:'',
    ocupacion: '',
    ingresoMensual: '',
    ingresoMoneda: 'C$',
    origenFondo: '2',
    origenFondoOtros: '',

    estatura:'',
    estaturaUnidades:'0',
    peso:'',
    pesoUnidades:'0',
    lateralidad:undefined,
    nCigar: '',

    nombreRepresentante: '',
    cedulaRepresentante: '',

    otherInsures: undefined,
    companyName: '',
    amount: '',
    coverages: '',
    clausulaArbitraje: undefined,
    questions : [
    ],

    sa: '',
    prima: '0',
    tipPago: undefined,
    primeraCuota: '0',
    pagoMoneda: 'U$',

    nombreTarjeta: '',
    numeroTarjeta: '',
    codigoSeguridad: '',
    fechaExpiracion: '',
    reference:'',

    beneficiarios: [{ ...beneficiarioDefault }],
    otherInsuresData: [
        
    ],
    showDialogRespQuestions: false,
    showDialogQuestions: false,
    showDialogBeneficiaries: false,
    showDialogPagoSuccess: false,
    showDialogConfirmAddress:false,
    showDialogGracias:false,

    viewTerminos: false,
    showDialogFinish: false,

    aceptTerminos:false,
   

    creating: false,
    faild: false,
    ...setObj(polizaMochaded)
};



const tramiteMochaded = isDevelopment
  ? {
      idtramite: 0,
      nombre1: "Eddy",
      nombre2: "Antonio",
      apellido1: "Ortiz",
      apellido2: "Amador",
      tipoIdentificacion: "1",
      identificacion: "570-050591-0000M",
      correo: "eortiza@lafise.com",
      celular: "57989684",
      figura: false,
      poseeCorreduria: "SI",
      nombreCorreduria: "LAFISE",
      fechaSiniestro:"",
      horaSiniestro:undefined,
      dia: "1",
      mes: "1",
      hora: "8",
      minutos: "59",
      tiempo: "AM",
      direccionSiniestro: "DIRECCION SINIESTRO",
      descripcionSiniestro: " DESCRIPCION SINIESTRO",
      idpoliza: "SOA-1800738-1358732-0",
      acceptaTerminos: true,
      guardandoRegistro:false,
      ShowModalFallo: false,
      MensajeError: "",
      ip:'-',
      vehiculoPropio:true,
        nombrePropietarioVehiculo : "Eddy Antonio Ortiz Amador",
        sePresentoPoliciaTransito: true,
        llamoServicioAsistencia: true,
        huboPropiedadDañada: true,
        resultaronTercerosLesionados:true,
    }
  : {};
 
export const tramiteDefault = {
  idtramite: 0,
  files: [],
  nombre1: "",
  nombre2: "",
  apellido1: "",
  apellido2: "",
  tipoIdentificacion: "1",
  identificacion: "",
  correo: "",
  celular: "",
  figura: undefined,
  poseeCorreduria: "SI",
  nombreCorreduria: "",
  fechaSiniestro:"",
  horaSiniestro:"",
  dia: "1",
  mes: "1",
  anio: new Date().getFullYear(),
  hora: "",
  minutos: "",
  tiempo: "",
  direccionSiniestro: "",
  descripcionSiniestro: "",
  idpoliza: "",
  imgCarnetSeguroVehiculo: [],
  imgIdentificacion: [],
  imgLicenciaConductor: [],
  imgDañoVehiculo: [],
  imgCirculacionVehiculo: [],
  imgCertificadoTransito: [],
  acceptaTerminos: false,
  creado: false,
  fallo: false,
   ShowModalFallo: false,
   ShowModalMensajeValidacion:false,
  guardandoRegistro:false,
  MensajeError: "",
  MensajeValidacion : "",
  vehiculoPropio:undefined,
  nombrePropietarioVehiculo : "",
  sePresentoPoliciaTransito: undefined,
  llamoServicioAsistencia: undefined,
  huboPropiedadDañada: undefined,
  resultaronTercerosLesionados:undefined,
  imgPlacaVehiculo: [],
  imgEntornoSiniestro: [],
  imgParteDelanteraVehiculo: [],
  imgParteTraseraVehiculo: [],
  imgParteLateralDerechaVehiculo: [],
  imgParteLateralIzquierdaVehiculo: [],
  Navegador:'',
  Dispositivo:'',
  OS:'',
  ip:'-',
  Lenguaje:'',
  ZonaHoraria:'',
  Resolucion: '',
  PuedeRecargarPagina: false,
  ...setObj(tramiteMochaded),
};
